import * as React from "react";
import { useEffect } from "react";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { useIntl } from "react-intl";
import { Button } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector, useDispatch } from "react-redux";
import { ROOT_API } from "../../../api/config";
import { ErrorCode } from "../../../api/ErrorCode";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { FormattedMessage } from "react-intl";
import { useForm, Resolver } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const schema = yup.object().shape({
  full_name: yup.string().required(<FormattedMessage id="name_not_blank" />),
  email: yup.string().required(<FormattedMessage id="email_not_blank" />),
  phone_number: yup
    .string()
    .required(<FormattedMessage id="phone_number_not_blank" />),
  password: yup.string().required(<FormattedMessage id="password_not_blank" />),
  confirm_password: yup
    .string()
    .oneOf(
      [yup.ref("password")],
      <FormattedMessage id="confirm_password_not_correct" />
    ),
});

export default function UsersTable() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(schema),
  });

  const intl = useIntl();

  const columns = [
    {
      field: "id",
      headerName: intl.formatMessage({
        id: "order",
      }),
      width: 70,
    },
    {
      field: "full_name",
      headerName: intl.formatMessage({
        id: "full_name",
      }),
      width: 180,
    },
    {
      field: "email",
      headerName: intl.formatMessage({
        id: "email",
      }),
      width: 200,
    },
    {
      field: "phone_number",
      headerName: intl.formatMessage({
        id: "phone_number",
      }),
      width: 150,
    },
    {
      field: "notification_methods",
      headerName: intl.formatMessage({
        id: "notification_methods",
      }),
      width: 100,
    },
    {
      field: "role",
      headerName: intl.formatMessage({
        id: "role",
      }),
      width: 100,
      valueGetter: ({ row }) => {
        return row.role === "common" ? "User" : "Admin";
      },
    },
    {
      field: "address",
      headerName: intl.formatMessage({
        id: "address_registered",
      }),
      width: 400,
      valueGetter: ({ row }) => {
        let address = "";
        const addresses = row.outage_registrations;
        console.log("ndphong addresses", addresses);
        addresses &&
          addresses.forEach((item) => {
            address =
              address +
              item.province_name +
              ", " +
              item.district_name +
              ", " +
              item.commune_name +
              ", " +
              item.street_name +
              "; ";
          });
        return address;
      },
    },
  ];

  const selectedLocale =
    useSelector((state) => state.lang.value) ||
    localStorage.getItem("lang") ||
    "hr";

  const [selectedItems, setSelectedItems] = React.useState([]);

  const [isLoading, setIsLoading] = React.useState(false);

  const [isLoadingCreateNew, setIsLoadingCreateNew] = React.useState(false);

  const [users, setUsers] = React.useState([]);

  const [role, setRoles] = React.useState("admin");

  const [isOpenCreateNew, setIsOpenCreateNew] = React.useState(false);

  const onSubmit = async (data) => {
    const newUser = {
      ...data,
      role,
    };

    console.log("ndphong newUser", newUser);
    const axiosObject = axios.create({
      headers: {
        "Content-Type": "application/json",
        lang: selectedLocale,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });
    try {
      const res = await axiosObject.post(
        `${ROOT_API}apis/admin-register`,
        newUser
      );

      if (res && res.data) {
        handleCloseCreateNew();
        Swal.fire({
          icon: "success",
          title: intl.formatMessage({
            id: "register_successfully",
          }),
          confirmButtonText: "OK",
        });
      }

      console.log("ndphong res", res);
    } catch (error) {
      handleCloseCreateNew();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error_code
            ? intl.formatMessage({
                id: ErrorCode[error.response.data.error_code],
              })
            : intl.formatMessage({
                id: "there_are_error_occured",
              }),
      });
    }
  };

  const handleCloseCreateNew = () => {
    reset();
    setIsOpenCreateNew(false);
  };

  const handleOpenCreateNewForm = () => {
    setIsOpenCreateNew(true);
  };

  const handleCheckUsers = async (type) => {
    Swal.fire({
      title: intl.formatMessage({
        id: "are_you_sure",
      }),
      text: intl.formatMessage({
        id: "you_wont_be_able_to_revert_this",
      }),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: intl.formatMessage({
        id: "yes_let_ban",
      }),
      cancelButtonText: intl.formatMessage({
        id: "no_cancel",
      }),
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const axiosObject = axios.create({
          headers: {
            "Content-Type": "application/json",
            lang: selectedLocale,
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        setIsLoading(true);
        try {
          const API_MODE =
            type === "ban-user" ? "ban-user" : "delete-subscriptions";
          const res = await axiosObject.post(`${ROOT_API}apis/${API_MODE}`, {
            email: "nguyendinhphonglove08+101@gmail.com",
          });
          if (res) {
            Swal.fire({
              icon: "success",
              title: intl.formatMessage({
                id: "delete_success",
              }),
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              error &&
              error.response &&
              error.response.data &&
              error.response.data.error_code
                ? intl.formatMessage({
                    id: ErrorCode[error.response.data.error_code],
                  })
                : intl.formatMessage({
                    id: "there_are_error_occured",
                  }),
          });
        }
        setIsLoading(false);
      }
    });

    console.log("ndphong selectedItem", selectedItems);
  };

  const getUsers = async () => {
    const axiosObject = axios.create({
      headers: {
        "Content-Type": "application/json",
        lang: selectedLocale,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });
    try {
      const res = await axiosObject.get(
        `${ROOT_API}apis/list-user-and-registed-locations`
      );
      if (res) {
        console.log("ndphong res", res);
        setUsers((res.data && res.data.data) || []);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error_code
            ? intl.formatMessage({
                id: ErrorCode[error.response.data.error_code],
              })
            : intl.formatMessage({
                id: "there_are_error_occured",
              }),
      });
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <div style={{ height: 560, width: "100%" }}>
      <Dialog
        open={isOpenCreateNew}
        onClose={handleCloseCreateNew}
        sx={{ margin: "0px" }}
      >
        <DialogTitle>{intl.formatMessage({ id: "create_new" })}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {intl.formatMessage({ id: "please_fill_all_fields_to_create_new" })}
          </DialogContentText>
          <form
            className="pt-36"
            style={{
              width: "400px",
            }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="general-form-main-form_group mb-12">
              <input
                className="px-10 py-12 radius-4 font-16"
                placeholder={intl.formatMessage({ id: "full_name" })}
                {...register("full_name")}
              />
              {errors.full_name && (
                <p className="error font-14 mt-2">{errors.full_name.message}</p>
              )}
            </div>
            <div className="general-form-main-form_group mb-12">
              <div className="general-form-main-form_group_code flex gap-10">
                <input
                  className="px-10 py-12 radius-4 font-16"
                  placeholder={intl.formatMessage({ id: "email" })}
                  {...register("email")}
                />
                {errors.email && (
                  <p className="error font-14 mt-2 general-form-main-form_group_code_title-phone">
                    {errors.email.message}
                  </p>
                )}
              </div>
            </div>
            <div className="general-form-main-form_group mb-12">
              <input
                className="px-10 py-12 radius-4 font-16"
                placeholder={intl.formatMessage({ id: "phone_number" })}
                {...register("phone_number")}
              />
              {errors.phone_number && (
                <p className="error font-14 mt-2">
                  {errors.phone_number.message}
                </p>
              )}
            </div>
            <div className="general-form-main-form_group mb-12">
              <input
                className="px-10 py-12 radius-4 font-16"
                placeholder={intl.formatMessage({ id: "password" })}
                type="password"
                {...register("password")}
              />
              {errors.password && (
                <p className="error font-14 mt-2">{errors.password.message}</p>
              )}
            </div>
            <div className="general-form-main-form_group mb-12">
              <input
                className="px-10 py-12 radius-4 font-16"
                placeholder={intl.formatMessage({
                  id: "confirm_password",
                })}
                type="password"
                {...register("confirm_password")}
              />
              {errors.confirm_password && (
                <p className="error font-14 mt-2">
                  {errors.confirm_password.message}
                </p>
              )}
            </div>
            <div className="general-form-main-form_group mb-12">
              <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">
                  {intl.formatMessage({
                    id: "role",
                  })}
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="admin"
                  name="radio-buttons-group"
                  onChange={(e) => {
                    setRoles(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="user"
                    control={<Radio />}
                    label={intl.formatMessage({
                      id: "user",
                    })}
                  />
                  <FormControlLabel
                    value="admin"
                    control={<Radio />}
                    label={intl.formatMessage({
                      id: "admin",
                    })}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </form>
        </DialogContent>
        <Box
          sx={{
            display: isLoadingCreateNew ? "flex" : "none",
            justifyContent: "center",
            marginBottom: "6px",
          }}
        >
          <CircularProgress />
        </Box>
        <DialogActions style={{ marginBottom: "12px", padding: "0px 24px" }}>
          <button
            className="btn-cta"
            style={{ width: "100%" }}
            type="submit"
            onClick={handleSubmit(onSubmit)}
          >
            {intl.formatMessage({ id: "submit" })}
          </button>
        </DialogActions>
      </Dialog>

      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          gap: "16px",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Button
            variant="contained"
            onClick={() => {
              handleCheckUsers("ban-user");
            }}
            disabled={!selectedItems.length}
            style={{ marginRight: "20px" }}
          >
            {intl.formatMessage({
              id: "ban",
            })}
          </Button>
          <Button
            variant="contained"
            disabled={!selectedItems.length}
            onClick={() => {
              handleCheckUsers("delete-subscriptions");
            }}
          >
            {intl.formatMessage({
              id: "cancel_subscription",
            })}
          </Button>
        </div>
        <div>
          <Button
            variant="contained"
            onClick={() => {
              handleOpenCreateNewForm();
            }}
          >
            {intl.formatMessage({
              id: "create_new",
            })}
          </Button>
        </div>
      </div>

      <DataGrid
        rows={
          (users &&
            users.map((item, index) => {
              return {
                ...item,
                id: index,
              };
            })) ||
          []
        }
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20, 50, 100, 200, 500]}
        checkboxSelection
        onRowSelectionModelChange={(ids) => {
          console.log("ids", ids);
          setSelectedItems(ids);
        }}
      />
    </div>
  );
}
